import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-technology-development',
  templateUrl: './technology-development.component.html',
  styleUrls: ['./technology-development.component.css']
})
export class TechnologyDevelopmentComponent implements OnInit {
  baseUrl = Constants.baseUrl;
  isBrowser:boolean=false;
  constructor(private viewportScroller: ViewportScroller,  
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta,private router: Router) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit(): void {
    if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500, once: true,});

    AOS.refresh;
  }
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/application-services/"
  },
  "headline": "Application Services",
  "description": "Our next-generation application development service empowers some of the world's most successful businesses to streamline complex operations.",
  "image": "https://mitresource.com/assets/images/application/application-bulidimage.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-06-25"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }
  private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('Application Development Services | Web & Mobile Apps');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: 'Maganti IT offers impactful mobile app development services to bring your project to market on every device and platform. Talk to our mobile app experts today!' },
      { property: 'og:type', content: 'website' },
      { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
      { property: 'og:title', content: 'Application Development Services | Web & Mobile Apps' },
      { property: 'og:url', content: 'https://mitresource.com/application-services/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/application/application-bulidimage.png' },
      { property: 'og:description', content: 'Maganti IT offers impactful mobile app development services to bring your project to market on every device and platform. Talk to our mobile app experts today!' },
    ]);
  }

}
